// extracted by mini-css-extract-plugin
export default {"imageSlider":"CartImage_imageSlider__dY96P","mainImage":"CartImage_mainImage__qFqsG","arrowContainer":"CartImage_arrowContainer__xnRMV","arrowButton":"CartImage_arrowButton__yYHdi"};